import { DetailR, Loader } from '@pensionbee/honeypot-ui';
import { twMerge } from 'tailwind-merge';

const DEFAULT_LOADING_LABEL = 'Loading, please wait';

type LoadingScreenProps = {
  message?: string;
  screenReaderMessage?: string;
  contained?: boolean;
};

const LoadingScreen = ({
  message,
  screenReaderMessage,
  contained,
}: LoadingScreenProps) => {
  return (
    <div
      className={twMerge(
        'fixed inset-0 z-50 flex flex-col items-center justify-center bg-background',
        contained && 'z-30 bg-transparent',
      )}
      role="status"
      aria-live="polite"
      aria-label={message || screenReaderMessage || DEFAULT_LOADING_LABEL}
    >
      <Loader aria-hidden="true" />
      {message && <DetailR className="mt-4">{message}</DetailR>}
    </div>
  );
};

export default LoadingScreen;
